export default __webpack_public_path__ + "static/media/project2.805f7f72.png";